// all builds except for evaluation version get this mockup
// the evaluation build gets actual codes
export default () => {};